import { ArrowLeft } from '@mui/icons-material'
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText } from 'components'
import { NeedsClusterReinstalledDetailsDto } from 'dtos'

import { VehicleClusterReinstallPhotosProps } from './index'
import VehicleCheckInStepper from './VehicleClusterReinstallStepper'
import CheckInReviewItem from '../checkIn/CheckInReviewItem'

interface Step4CheckInReviewProps extends VehicleClusterReinstallPhotosProps {
  onBack: () => void
  onNext: () => void
  vehicleOdometerReadingDetails: NeedsClusterReinstalledDetailsDto
  vehicleGuid?: string
}

export default function Step4CheckInReview({
  onBack,
  onNext,
  vehicleOdometerReadingDetails,
  vehicleGuid,
  importerDoorLabelPhoto,
  setImporterDoorLabelPhoto,
  comboPhoto,
  setComboPhoto,
  clusterWithOdometerPhoto,
  setClusterWithOdometerPhoto,
  odometerAfterModificationPhoto,
  setOdometerAfterModificationPhoto
}: Step4CheckInReviewProps) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={12}>
            <VehicleCheckInStepper activeStep={2} />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Typography fontWeight='bold' variant='body1'>
              Odometer Reading Details
            </Typography>
          </Grid>

          <CheckInReviewItem complete label='Odometer Reading Details' />

          <Grid item xs={12} mt={3}>
            <Typography fontWeight='bold' variant='body1'>
              Cluster Reinstall Photos
            </Typography>
          </Grid>

          <CheckInReviewItem
            complete={Boolean(importerDoorLabelPhoto.documentGuid)}
            label='Importer Door Label'
          />

          <CheckInReviewItem complete={Boolean(comboPhoto.documentGuid)} label='Combo' />

          <CheckInReviewItem
            complete={Boolean(clusterWithOdometerPhoto.documentGuid)}
            label='Speedometer After Modification'
          />

          <CheckInReviewItem
            complete={Boolean(odometerAfterModificationPhoto.documentGuid)}
            label='Odometer After Modification'
          />

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Vehicle Needs Cluster Reinstalled Steps:**

Vehicle Needs Cluster Reinstalled Steps: Displays the current step
of the vehicle in the Needs Cluster Reinstall process.

**Speedometer After Modification Photo Check Mark:**

Displays a check mark to indicate that the Speedometer After Modification
Photo has been successfully uploaded.

**Importer Door Label Photo Check Mark:**

Displays a check mark to indicate that the Importer Door Label
Photo has been successfully uploaded.

**Combo Photo Check Mark:**

Displays a check mark to indicate that the Combo Photo has been
successfully uploaded.

**SUBMIT Button:**

Clicking this button will:

   - Upload the photos.

   - Record the name of the user who completed the process, along
with a date/time stamp for the "Cluster Reinstallation Complete"
action.

   - Return the user to the "Needs Cluster Reinstalled" to-do list
screen.

**PREVIOUS Button:**

Clicking this button will:

   - Return the user to the previous step in the process.

`}
            </GreenText>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' fullWidth onClick={onNext} type='submit' variant='contained'>
              SUBMIT
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' startIcon={<ArrowLeft />} fullWidth onClick={onBack} variant='outlined'>
              PREVIOUS
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
